﻿export const IdaLoginClaimTypes = {
    IdaUserNumber: 'http://kl.ida.dk/identity/claims/IdaUserNumber',
    IdaUserCreationTimestamp: 'http://kl.ida.dk/identity/claims/IdaUserCreationTimestamp',
    LeadId: 'http://kl.ida.dk/identity/claims/LeadId',
    PlusContent: 'http://kl.ida.dk/identity/claims/PlusContent',
};

export const IdaLoginRoleTypes = {
    IDAMember: 'IDAMember',
    IDAStudyMember: 'IDAStudyMember',
    DDLMember: 'DDLMember',
    DDLStudyMember: 'DDLStudyMember',
    IDAActive: 'IDAActive',
};

export const IdaLoginScopeTypes = {
    PlusContent: 'plus_content',
    Roles: 'roles',
};